import { ScalableFontSizeInputComponent } from './scalable-font-size-input';
export const ScalableFontSizeInput = ScalableFontSizeInputComponent;